// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.settings-users__content-wrapper {
	background-color: white;
	min-height: calc(100vh - 1px);
	display: flex;
	flex-direction: column;
	padding: 30px 24px 24px 0;
}

.settings-users__content {
	display: flex;
	flex-direction: column;
	width: 100%;
	gap: 24px;
	padding: 24px;
	background-color: #f2f2f2;
	border-radius: 10px;
	border-top-left-radius: 0px;
}

.settings-users__block {
	padding: 24px;
	background-color: white;
	width: 100%;
	border-radius: 10px;
	display: flex;
	flex-direction: column;
	gap: 24px;
}

.settings-users__two-blocks-in-row {
	display: grid;
	grid-template-columns: calc(50% - 12px) calc(50% - 12px);
	gap: 24px;
}

.settings-users__block-body {
	display: flex;
	flex-direction: column;
	gap: 16px;
	height: 100%;
}

.settings-users__block-info-row {
	font-size: 16px;
	line-height: 20px;
	color: #666666;
}

.settings-users__block-info-row-value {
	font-size: 16px;
	line-height: 20px;
	color: #191919;
	font-weight: 500;
}

.setting-users__block-info-wrapper {
	height: 100%;
	display: flex;
	flex-direction: column;
	gap: 16px;
}

.settings-users__block-body-header {
	display: flex;
	align-items: center;
	justify-content: space-between;
}

.settings-users__block-body-tabs {
	display: flex;
	align-items: center;
	gap: 8px;
}

.settings-users__block-body-tabs h5 {
	cursor: pointer;
	color: #666666;
	border-bottom: 2px solid transparent;
	padding: 4px 12px;
}

.settings-users__block-body-tabs h5.active-tab {
	color: #191919;
	border-bottom: 2px solid #191919;
}

.settings-users__block-body-header-buttons {
	display: flex;
	align-items: center;
	gap: 16px;
}

.bg-light {
	--bs-bg-opacity: 1;
	background-color: transparent !important;
}

.text-right {
	text-align: right !important;
}

.dashboard-body {
	box-shadow: 0px 0px 25px 5px rgb(66 147 208 / 25%);
	position: relative;
	padding: 10px 25px;
	background: #f3faff;
}

.settings-card {
	box-shadow: 0px 0px 25px 5px rgb(66 147 208 / 25%);
	background-color: #f3faff;
}

.dashboard-menu-ul {
	display: flex;
	padding: 0 !important;
}

.h-75 {
	height: 75% !important;
}

.dashboard-menu-li {
	display: flex;
	cursor: pointer;
	position: relative;
}

.dashboard-menu-a {
	padding: 10px;
	display: flex;
	font-weight: 400;
	text-decoration: none;
	color: #1a4074;
	transition: all 0.5s;
	position: relative;
	border-bottom: 2px solid #1c6fd1;
}

.dashboard-body-settings {
	margin-top: 15px;
}

.dashboard-body-li {
	width: 100%;
}

.active-text {
	color: #1c6fd1;
}

.dashboard-menu-button {
	border: 1px solid rgba(28, 111, 209, 0.5);
	color: #1c6fd1;
	background: #f1f9ff;
	padding: 4px 20px;
	font-weight: 400;
	font-size: 16px;
}

.table {
	width: 100%;
	margin-bottom: 1rem;
	color: #212529;
	text-align: left;
	border-collapse: collapse;
}

.table .thead-light th {
	color: #666666;
	font-weight: 400;
	border: none;
}

.add-integration-image {
	width: 50px;
	margin-right: 5px;
}

.square-white-button {
	border: none;
	width: 30px;
	height: 30px;
	box-shadow:
		0 1px 3px 0 rgba(0, 0, 0, 0.3),
		0 0 0 1px rgba(0, 0, 0, 0.04);
	border-radius: 3px;
	padding: 0;
	background-color: white;
	display: flex;
	align-items: center;
	justify-content: center;
}

.rates-table-body tr td {
	padding-top: 12px !important;
	padding-bottom: 12px !important;
}
`, "",{"version":3,"sources":["webpack://./src/app/pages/Dashboard/SettingsUsers/SettingsUsers.css"],"names":[],"mappings":"AAAA;CACC,uBAAuB;CACvB,6BAA6B;CAC7B,aAAa;CACb,sBAAsB;CACtB,yBAAyB;AAC1B;;AAEA;CACC,aAAa;CACb,sBAAsB;CACtB,WAAW;CACX,SAAS;CACT,aAAa;CACb,yBAAyB;CACzB,mBAAmB;CACnB,2BAA2B;AAC5B;;AAEA;CACC,aAAa;CACb,uBAAuB;CACvB,WAAW;CACX,mBAAmB;CACnB,aAAa;CACb,sBAAsB;CACtB,SAAS;AACV;;AAEA;CACC,aAAa;CACb,wDAAwD;CACxD,SAAS;AACV;;AAEA;CACC,aAAa;CACb,sBAAsB;CACtB,SAAS;CACT,YAAY;AACb;;AAEA;CACC,eAAe;CACf,iBAAiB;CACjB,cAAc;AACf;;AAEA;CACC,eAAe;CACf,iBAAiB;CACjB,cAAc;CACd,gBAAgB;AACjB;;AAEA;CACC,YAAY;CACZ,aAAa;CACb,sBAAsB;CACtB,SAAS;AACV;;AAEA;CACC,aAAa;CACb,mBAAmB;CACnB,8BAA8B;AAC/B;;AAEA;CACC,aAAa;CACb,mBAAmB;CACnB,QAAQ;AACT;;AAEA;CACC,eAAe;CACf,cAAc;CACd,oCAAoC;CACpC,iBAAiB;AAClB;;AAEA;CACC,cAAc;CACd,gCAAgC;AACjC;;AAEA;CACC,aAAa;CACb,mBAAmB;CACnB,SAAS;AACV;;AAEA;CACC,kBAAkB;CAClB,wCAAwC;AACzC;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,kDAAkD;CAClD,kBAAkB;CAClB,kBAAkB;CAClB,mBAAmB;AACpB;;AAEA;CACC,kDAAkD;CAClD,yBAAyB;AAC1B;;AAEA;CACC,aAAa;CACb,qBAAqB;AACtB;;AAEA;CACC,sBAAsB;AACvB;;AAEA;CACC,aAAa;CACb,eAAe;CACf,kBAAkB;AACnB;;AAEA;CACC,aAAa;CACb,aAAa;CACb,gBAAgB;CAChB,qBAAqB;CACrB,cAAc;CACd,oBAAoB;CACpB,kBAAkB;CAClB,gCAAgC;AACjC;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,WAAW;AACZ;;AAEA;CACC,cAAc;AACf;;AAEA;CACC,yCAAyC;CACzC,cAAc;CACd,mBAAmB;CACnB,iBAAiB;CACjB,gBAAgB;CAChB,eAAe;AAChB;;AAEA;CACC,WAAW;CACX,mBAAmB;CACnB,cAAc;CACd,gBAAgB;CAChB,yBAAyB;AAC1B;;AAEA;CACC,cAAc;CACd,gBAAgB;CAChB,YAAY;AACb;;AAEA;CACC,WAAW;CACX,iBAAiB;AAClB;;AAEA;CACC,YAAY;CACZ,WAAW;CACX,YAAY;CACZ;;+BAE8B;CAC9B,kBAAkB;CAClB,UAAU;CACV,uBAAuB;CACvB,aAAa;CACb,mBAAmB;CACnB,uBAAuB;AACxB;;AAEA;CACC,4BAA4B;CAC5B,+BAA+B;AAChC","sourcesContent":[".settings-users__content-wrapper {\n\tbackground-color: white;\n\tmin-height: calc(100vh - 1px);\n\tdisplay: flex;\n\tflex-direction: column;\n\tpadding: 30px 24px 24px 0;\n}\n\n.settings-users__content {\n\tdisplay: flex;\n\tflex-direction: column;\n\twidth: 100%;\n\tgap: 24px;\n\tpadding: 24px;\n\tbackground-color: #f2f2f2;\n\tborder-radius: 10px;\n\tborder-top-left-radius: 0px;\n}\n\n.settings-users__block {\n\tpadding: 24px;\n\tbackground-color: white;\n\twidth: 100%;\n\tborder-radius: 10px;\n\tdisplay: flex;\n\tflex-direction: column;\n\tgap: 24px;\n}\n\n.settings-users__two-blocks-in-row {\n\tdisplay: grid;\n\tgrid-template-columns: calc(50% - 12px) calc(50% - 12px);\n\tgap: 24px;\n}\n\n.settings-users__block-body {\n\tdisplay: flex;\n\tflex-direction: column;\n\tgap: 16px;\n\theight: 100%;\n}\n\n.settings-users__block-info-row {\n\tfont-size: 16px;\n\tline-height: 20px;\n\tcolor: #666666;\n}\n\n.settings-users__block-info-row-value {\n\tfont-size: 16px;\n\tline-height: 20px;\n\tcolor: #191919;\n\tfont-weight: 500;\n}\n\n.setting-users__block-info-wrapper {\n\theight: 100%;\n\tdisplay: flex;\n\tflex-direction: column;\n\tgap: 16px;\n}\n\n.settings-users__block-body-header {\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: space-between;\n}\n\n.settings-users__block-body-tabs {\n\tdisplay: flex;\n\talign-items: center;\n\tgap: 8px;\n}\n\n.settings-users__block-body-tabs h5 {\n\tcursor: pointer;\n\tcolor: #666666;\n\tborder-bottom: 2px solid transparent;\n\tpadding: 4px 12px;\n}\n\n.settings-users__block-body-tabs h5.active-tab {\n\tcolor: #191919;\n\tborder-bottom: 2px solid #191919;\n}\n\n.settings-users__block-body-header-buttons {\n\tdisplay: flex;\n\talign-items: center;\n\tgap: 16px;\n}\n\n.bg-light {\n\t--bs-bg-opacity: 1;\n\tbackground-color: transparent !important;\n}\n\n.text-right {\n\ttext-align: right !important;\n}\n\n.dashboard-body {\n\tbox-shadow: 0px 0px 25px 5px rgb(66 147 208 / 25%);\n\tposition: relative;\n\tpadding: 10px 25px;\n\tbackground: #f3faff;\n}\n\n.settings-card {\n\tbox-shadow: 0px 0px 25px 5px rgb(66 147 208 / 25%);\n\tbackground-color: #f3faff;\n}\n\n.dashboard-menu-ul {\n\tdisplay: flex;\n\tpadding: 0 !important;\n}\n\n.h-75 {\n\theight: 75% !important;\n}\n\n.dashboard-menu-li {\n\tdisplay: flex;\n\tcursor: pointer;\n\tposition: relative;\n}\n\n.dashboard-menu-a {\n\tpadding: 10px;\n\tdisplay: flex;\n\tfont-weight: 400;\n\ttext-decoration: none;\n\tcolor: #1a4074;\n\ttransition: all 0.5s;\n\tposition: relative;\n\tborder-bottom: 2px solid #1c6fd1;\n}\n\n.dashboard-body-settings {\n\tmargin-top: 15px;\n}\n\n.dashboard-body-li {\n\twidth: 100%;\n}\n\n.active-text {\n\tcolor: #1c6fd1;\n}\n\n.dashboard-menu-button {\n\tborder: 1px solid rgba(28, 111, 209, 0.5);\n\tcolor: #1c6fd1;\n\tbackground: #f1f9ff;\n\tpadding: 4px 20px;\n\tfont-weight: 400;\n\tfont-size: 16px;\n}\n\n.table {\n\twidth: 100%;\n\tmargin-bottom: 1rem;\n\tcolor: #212529;\n\ttext-align: left;\n\tborder-collapse: collapse;\n}\n\n.table .thead-light th {\n\tcolor: #666666;\n\tfont-weight: 400;\n\tborder: none;\n}\n\n.add-integration-image {\n\twidth: 50px;\n\tmargin-right: 5px;\n}\n\n.square-white-button {\n\tborder: none;\n\twidth: 30px;\n\theight: 30px;\n\tbox-shadow:\n\t\t0 1px 3px 0 rgba(0, 0, 0, 0.3),\n\t\t0 0 0 1px rgba(0, 0, 0, 0.04);\n\tborder-radius: 3px;\n\tpadding: 0;\n\tbackground-color: white;\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: center;\n}\n\n.rates-table-body tr td {\n\tpadding-top: 12px !important;\n\tpadding-bottom: 12px !important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
